import { useEducationalYearsQuery } from 'api/generated';
import { getBaseOptions } from 'api/wrappers';
export const useEducationalYearsQueryApi = (variables, options) => {
    const { data, ...rest } = useEducationalYearsQuery(getBaseOptions(variables ?? {}, {
        ...options,
        fetchPolicy: 'cache-first',
    }));
    const educationalYears = data?.educationalYears ?? [];
    return { ...rest, data: educationalYears };
};
